import { render, staticRenderFns } from "./artistV2.vue?vue&type=template&id=0a10f532&scoped=true"
import script from "./artistV2.vue?vue&type=script&lang=js"
export * from "./artistV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a10f532",
  null
  
)

export default component.exports